/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Performer } from './Performer';
import {
    PerformerFromJSON,
    PerformerFromJSONTyped,
    PerformerToJSON,
    PerformerToJSONTyped,
} from './Performer';
import type { DealTypeEnum } from './DealTypeEnum';
import {
    DealTypeEnumFromJSON,
    DealTypeEnumFromJSONTyped,
    DealTypeEnumToJSON,
    DealTypeEnumToJSONTyped,
} from './DealTypeEnum';

/**
 * Serializer for ShowPerformer through model.
 * @export
 * @interface ShowPerformer
 */
export interface ShowPerformer {
    /**
     * 
     * @type {string}
     * @memberof ShowPerformer
     */
    readonly id: string;
    /**
     * 
     * @type {string}
     * @memberof ShowPerformer
     */
    show: string;
    /**
     * 
     * @type {Performer}
     * @memberof ShowPerformer
     */
    readonly performer: Performer;
    /**
     * 
     * @type {string}
     * @memberof ShowPerformer
     */
    performerId: string;
    /**
     * 1 = headliner, 2 = support, etc.
     * @type {number}
     * @memberof ShowPerformer
     */
    billingOrder?: number;
    /**
     * 
     * @type {string}
     * @memberof ShowPerformer
     */
    setTime?: string | null;
    /**
     * Set length in minutes
     * @type {number}
     * @memberof ShowPerformer
     */
    setDuration?: number | null;
    /**
     * 
     * @type {DealTypeEnum}
     * @memberof ShowPerformer
     */
    dealType?: DealTypeEnum;
    /**
     * Fixed payment amount
     * @type {string}
     * @memberof ShowPerformer
     */
    guaranteeAmount?: string | null;
    /**
     * Percentage of revenue (e.g., 85.00 for 85%)
     * @type {string}
     * @memberof ShowPerformer
     */
    percentage?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ShowPerformer
     */
    isPaid?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof ShowPerformer
     */
    paymentDate?: Date | null;
    /**
     * Final payment amount
     * @type {string}
     * @memberof ShowPerformer
     */
    actualPayment?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ShowPerformer
     */
    readonly calculatedPayment: string;
    /**
     * 
     * @type {string}
     * @memberof ShowPerformer
     */
    notes?: string;
    /**
     * 
     * @type {Date}
     * @memberof ShowPerformer
     */
    readonly createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ShowPerformer
     */
    readonly updatedAt: Date;
}



/**
 * Check if a given object implements the ShowPerformer interface.
 */
export function instanceOfShowPerformer(value: object): value is ShowPerformer {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('show' in value) || value['show'] === undefined) return false;
    if (!('performer' in value) || value['performer'] === undefined) return false;
    if (!('performerId' in value) || value['performerId'] === undefined) return false;
    if (!('calculatedPayment' in value) || value['calculatedPayment'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function ShowPerformerFromJSON(json: any): ShowPerformer {
    return ShowPerformerFromJSONTyped(json, false);
}

export function ShowPerformerFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowPerformer {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'show': json['show'],
        'performer': PerformerFromJSON(json['performer']),
        'performerId': json['performer_id'],
        'billingOrder': json['billing_order'] == null ? undefined : json['billing_order'],
        'setTime': json['set_time'] == null ? undefined : json['set_time'],
        'setDuration': json['set_duration'] == null ? undefined : json['set_duration'],
        'dealType': json['deal_type'] == null ? undefined : DealTypeEnumFromJSON(json['deal_type']),
        'guaranteeAmount': json['guarantee_amount'] == null ? undefined : json['guarantee_amount'],
        'percentage': json['percentage'] == null ? undefined : json['percentage'],
        'isPaid': json['is_paid'] == null ? undefined : json['is_paid'],
        'paymentDate': json['payment_date'] == null ? undefined : (new Date(json['payment_date'])),
        'actualPayment': json['actual_payment'] == null ? undefined : json['actual_payment'],
        'calculatedPayment': json['calculated_payment'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

  export function ShowPerformerToJSON(json: any): ShowPerformer {
      return ShowPerformerToJSONTyped(json, false);
  }

  export function ShowPerformerToJSONTyped(value?: Omit<ShowPerformer, 'id'|'performer'|'calculated_payment'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'show': value['show'],
        'performer_id': value['performerId'],
        'billing_order': value['billingOrder'],
        'set_time': value['setTime'],
        'set_duration': value['setDuration'],
        'deal_type': DealTypeEnumToJSON(value['dealType']),
        'guarantee_amount': value['guaranteeAmount'],
        'percentage': value['percentage'],
        'is_paid': value['isPaid'],
        'payment_date': value['paymentDate'] == null ? undefined : ((value['paymentDate'] as any).toISOString().substring(0,10)),
        'actual_payment': value['actualPayment'],
        'notes': value['notes'],
    };
}

